<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <!-- <a-form-item label="岗位类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-select
          optionFilterProp="children"
          v-decorator="[
          'type_id',
          {rules: [{ required: true, message: '请选择岗位类型!' }]}
        ]"
          placeholder="请选择岗位类型"
          @change="typeSelectChange"
        >
          <a-select-option v-for="(item,i) in typeList" :key="i" :value="item.value">{{item.label}}</a-select-option>
        </a-select>
      </a-form-item> -->
      <!-- <a-form-item
        v-show="HideInRoleList"
        label="岗位名称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-select
          mode="multiple"
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'role_id_list',
            { rules: [{ required: true, message: '请选择岗位名称!' }] }
          ]"
          placeholder="请选择岗位名称"
        >
          <a-select-option
            v-for="(item, i) in roleList"
            :key="i"
            :value="item.id"
            >{{ item.role_name }}</a-select-option
          >
        </a-select>
      </a-form-item> -->
      <a-form-item
        label="用户名称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'user_name',
            { rules: [{ required: true, message: '请填写用户名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item
        label="手机号码"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'phone',
            {
              rules: [{ required: true, message: '请输入您的手机号码!' }]
            }
          ]"
        >
          <a-select
            slot="addonBefore"
            v-decorator="['prefix', { initialValue: '86' }]"
          >
            <a-select-option value="86">+86</a-select-option>
            <a-select-option value="87">+87</a-select-option>
          </a-select>
        </a-input>
      </a-form-item>

      <!-- <a-form-item label="密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-input
          v-decorator="[
          'password',
          {rules: [{ required: true, message: '请填写用户密码!' }]}
        ]"
        />
      </a-form-item> -->
      <a-form-item
        label="性别"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-radio-group v-decorator="['gender']">
          <a-radio
            v-for="(item, i) in genderRadio"
            :key="i"
            :value="item.value"
            >{{ item.label }}</a-radio
          >
        </a-radio-group>
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      roleList: [],
      typeList: [
        {
          label: "员工",
          value: 1
        },
        {
          label: "员工",
          value: 2
        },
        {
          label: "客户",
          value: 3
        }
      ],
      HideInRoleList: false,
      user_id: "",
      password: "",
      genderRadio: [
        {
          label: "男",
          value: 1
        },
        {
          label: "女",
          value: 2
        },
        {
          label: "未知",
          value: 0
        }
      ]
    };
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.form = this.$form.createForm(this, {
        onFieldsChange: (_, changedFields) => {
          this.$emit("change", changedFields);
        },
        mapPropsToFields: () => {
          this.user_id = this.editDetail.id;
          let role_info = [];
          this.editDetail.role_info.forEach(element => {
            role_info.push(element.id);
          });
          this.typeSelectChange(this.editDetail.role_info[0].role_type);
          return {
            user_name: this.$form.createFormField({
              ...this.user_name,
              value: this.editDetail.user_name
            }),
            phone: this.$form.createFormField({
              ...this.phone,
              value: this.editDetail.phone
            }),
            gender: this.$form.createFormField({
              ...this.gender,
              value: this.editDetail.gender
            }),
            type_id: this.$form.createFormField({
              ...this.role_type,
              value: this.editDetail.role_info[0].role_type
            }),
            role_id_list: this.$form.createFormField({
              ...this.role_id_list,
              value: role_info
            })
          };
        },
        onValuesChange(_, values) {}
      });
      // console.log(this.form);
    }
  },
  mounted() {},
  methods: {
    getRoleList(type) {
      const url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      const pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 100000,
        role_type: type
      };
      axios
        .post(url, pramas)
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.roleList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$store.state.token)
      this.form.validateFields((err, value) => {
        if (!err) {
          let url =
            this.httpsBasic.url + this.httpsBasic.user + "User/editUser";
          let pramas = {
            user_id: this.user_id,
            user_name: value.user_name,
            phone: value.phone,
            gender: value.gender,
            token: window.localStorage.getItem("xnwfPcToken")
            // password: value.password,
            // role_id_list: value.role_id_list
          };
          if (pramas.gender == undefined) {
            delete pramas.gender;
          }
          if (pramas.password == undefined) {
            delete pramas.password;
          }
          // console.log(pramas);
          axios
            .post(url, pramas)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        } else {
          this.$message.warning("请选择对应岗位");
        }
      });
    },
    typeSelectChange(value) {
      this.HideInRoleList = true;
      this.getRoleList(value);
      //  console.log(value);
      //   this.form.setFieldsValue({
      //     note: `Hi, ${value === "male" ? "man" : "lady"}!`
      //   });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 4% 4% 0;
  padding-bottom: 50px;
}
</style>
